import { setInstances } from './indirection';
import { portalUserService } from './PortalUserService';
import { useCurrentUser, useIsExtraFeatureEnabled, useCurrentCompanyId, useUserHasPermission } from './hooks';

setInstances({
    portalUserService,
    useCurrentUser,
    useUserHasPermission,
    useIsExtraFeatureEnabled,
    useCurrentCompanyId,
});
